import { render, staticRenderFns } from "./dashRemessas.vue?vue&type=template&id=1d539792"
import script from "./dashRemessas.vue?vue&type=script&lang=js"
export * from "./dashRemessas.vue?vue&type=script&lang=js"
import style0 from "./dashRemessas.vue?vue&type=style&index=0&id=1d539792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports